__turbopack_context__.v({
  "ratings": "ReviewRatings-module-scss-module__JVPQAa__ratings",
});
